import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import drawerReducer from "./Drawer/drawer.reducer";
import userReducer from "./User/user.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  drawer: drawerReducer,
  user: userReducer,
});

export default persistReducer(persistConfig, rootReducer);
